import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AccountingList from '@components/obsolete/accounting-list/AccountingList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const AccountingListPage: React.FC<ComponentProps> = () => {
  return (
    <>
      <ResponsiveLayout>
        <AccountingList />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(AccountingListPage);
